<section id="services" class="services" #element>
  <div class="component-content">
    <h3 class="services__title">{{headline}}</h3>
    <app-preview-list [items]="services| async"></app-preview-list>
  </div>
</section>